import React, { FC } from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';

import OkDialog from '../../component/OkDialog';

import { EventSummary } from '../../model/EnquirySummary';

import './EventDetails.less';

//
// Display event details to the user
//

const EventDetailsDialog: FC<{
  open: boolean,
  eventSummary?: EventSummary,
  onExit: () => void,
}> = ({
  open, eventSummary, onExit
}) => {
  const { t } = useTranslation();
  
  const eventColumns: any[] = [
    {
      title: t('event.details.dialog.data.key'),
      dataIndex: 'key'
    },
    {
      title: t('event.details.dialog.data.value'),
      dataIndex: 'value'
    }
  ];
  
  // extract the event's data
  const getFieldName = (fieldName: string) => {
    const name = t(`event.details.dialog.data.${fieldName}`);
    if (name) return name;
    else return fieldName;
  }

  const eventData: any[] = [];
  try {
    if (eventSummary?.data != null) {
      const data = JSON.parse(eventSummary?.data);
      for (const eventDataKey in data) {
        const date = new Date(data[eventDataKey]);
        if (isNaN(date.valueOf())) eventData.push({key: getFieldName(eventDataKey), value: data[eventDataKey]})
        else eventData.push({key: getFieldName(eventDataKey), value: date.toLocaleString()});
      }
    }
  } catch (e) {
    eventData.push({ key: t('event.details.dialog.data.data'), value: eventSummary?.data });
  }

  return (
    <OkDialog
      title={t('event.details.dialog.title')}
      open={open}
      onExit={onExit}
      className='event-details-dialog'
    >
      <div className="event-details-dialog-content">
        <table className="event-details-dialog-table">
          <tbody>
            <tr>
              <th>{t('event.details.dialog.event.type')}</th>
              <td>{eventSummary?.eventType}</td>
            </tr>
            <tr>
              <th>{t('event.details.dialog.event.sequence')}</th>
              <td>{eventSummary?.version}</td>
            </tr>
            <tr>
              <th>{t('event.details.dialog.event.timestamp')}</th>
              <td>{eventSummary?.eventTransactionTS?.toLocaleString()}</td>
            </tr>
          </tbody>
        </table>
        <Table
          className="event-data-table"
          columns={eventColumns}
          dataSource={eventData}
          rowKey="key"
          pagination={false}
        />
      </div>
    </OkDialog>
  );
};

export default EventDetailsDialog;